<template>
  <div id="app" class="app">
    <Home></Home>
  </div>
</template>

<script>
import Home from './views/home'
export default {
  name: 'App',
  components: {
    Home
  },
}
</script>

<style>
html, body {
    /* width: 1423px; */
    /* height: 790px; */
    padding: 0;
    margin: 0;
    
    font-size: 14px;
    color: rgb(75, 75, 75);
    text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
}
</style>
